import { _ScheduleType as ScheduleType } from '@vectronic/desktop-api';
import { dsDtos } from '@vectronic/openApi-admin';

export class ScheduleHelp {
  static commandServices() {
    return [
      ScheduleType.COMMUNICATION,
      ScheduleType.VHF,
      ScheduleType.PROXIMITY,
      ScheduleType.GPS,
      ScheduleType.SOLEX_GPS,
      ScheduleType.EXTERNAL_SENSOR_RECEIVER,
    ] as const;
  }

  static services() {
    return [...this.commandServices(), ScheduleType.VIRTUAL_FENCE] as const;
  }

  static telemetry() {
    return [
      ScheduleType.GPS,
      ScheduleType.PROXIMITY,
      ScheduleType.COMMUNICATION,
      ScheduleType.VHF,
      ScheduleType.CAMERA,
      ScheduleType.VIRTUAL_FENCE,
      ScheduleType.SOLEX_GPS,
    ] as const;
  }

  static toLowerCase(type: `${ScheduleType}` | undefined) {
    switch (type) {
      case ScheduleType.COMMUNICATION:
        return 'Communication';
      case ScheduleType.VHF:
        return 'Beacon';
      case ScheduleType.PROXIMITY:
        return 'Proximity';
      case ScheduleType.GPS:
        return 'GPS';
      case ScheduleType.SOLEX_GPS:
        return 'Solex GPS';
      case ScheduleType.CAMERA:
        return 'Camera';
      case ScheduleType.VIRTUAL_FENCE:
        return 'Virtual Fence';
    }
  }

  static areSchedulesEqual(s1?: dsDtos.Schedule, s2?: dsDtos.Schedule) {
    return JSON.stringify(this.cleanSchedule(s1)) === JSON.stringify(this.cleanSchedule(s2));
  }

  private static cleanSchedule(schedule?: dsDtos.Schedule) {
    if (!schedule) return;
    return {
      scheduleType: schedule.scheduleType,
      rules: this.cleanRules(schedule.rules),
      cameraScheduleRules: this.cleanRules(schedule.cameraScheduleRules),
    };
  }

  static cleanRules<T extends dsDtos.ScheduleRule | dsDtos.CameraScheduleRule>(rules?: T[]): T[] {
    if (!rules) return [];
    return rules
      .map((rule) => {
        if (!rule) return undefined;
        const cleaned: any = { ...rule };
        delete cleaned.id;
        delete cleaned.scheduleId;
        delete cleaned.ruleId;
        delete cleaned.collarId;
        delete cleaned.deviceId;
        if (cleaned.startTime && typeof cleaned.startTime === 'string') {
          cleaned.startTime = cleaned.startTime.slice(0, 10);
        }
        if (cleaned.endTime && typeof cleaned.endTime === 'string') {
          cleaned.endTime = cleaned.endTime.slice(0, 10);
        }
        if (
          !('cameraScheduleRuleType' in cleaned) &&
          (cleaned.skipCount === undefined || cleaned.skipCount === null)
        ) {
          cleaned.skipCount = 0;
        }
        if (Array.isArray(cleaned.sequences)) {
          cleaned.sequences = cleaned.sequences
            .map((seq: any) => {
              if (!seq) return undefined;
              const cleanedSeq = { ...seq };
              delete cleanedSeq.id;
              delete cleanedSeq.ruleId;
              return cleanedSeq;
            })
            .filter(Boolean);
          if (!cleaned.sequences.length) delete cleaned.sequences;
        } else {
          delete cleaned.sequences;
        }
        return cleaned as T;
      })
      .filter((rule): rule is T => Boolean(rule));
  }
}
